
const RESOLUTIONS = [
    2048.256,
    1024.128,
    512.064,
    256.032,
    128.016,
    64.008,
    32.004,
    16.002,
    8.001,
    4.0005,
    2.00025,
    1.000125,
    0.5000625,
    0.25003125,
    0.125015625,
    0.0625078125
];

const CUZK_WMTS_TILE_GRID = {
    extent: [
        -925000.000000000000, -1444353.535999999800,
        -400646.464000000040, -920000.000000000000
    ],
    projection: 'epsg:5514',
    resolutions: RESOLUTIONS,
    matrixIds: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15']
};

const MAP_PROJECT = {
    projection: 'epsg:5514',
    resolutions: RESOLUTIONS,
    extent: [
        -925000.000000000000, -1444353.535999999800,
        -400646.464000000040, -920000.000000000000
    ],
    minZoom: 0,
    maxZoom: 15,

    layers: [{
        id: 'zm',
        type: 'WMTS',
        source: {
            params: {
                url: 'https://ags.cuzk.gov.cz/arcgis1/rest/services/ZTM/MapServer/WMTS',
                layer: 'ZTM',
                matrixSet: 'default028mm',
                projection: 'epsg:5514',
                format: 'image/png',
                style: 'default'
            },
            tileGrid: CUZK_WMTS_TILE_GRID
        }
    }, {
        id: 'orto',
        type: 'WMTS',
        source: {
            params: {
                url: 'https://ags.cuzk.gov.cz/arcgis1/rest/services/ORTOFOTO/MapServer/WMTS',
                layer: 'ORTOFOTO',
                matrixSet: 'default028mm',
                projection: 'EPSG:5514',
                format: 'image/jpeg',
                style: 'default'
            },
            tileGrid: CUZK_WMTS_TILE_GRID
        }
    }, {
        id: 'cuzk_km',
        type: 'ImageWMS',
        source: {
            url: 'https://services.cuzk.cz/wms/local-KM-wms.asp',
            params: {'LAYERS': 'KN'},
            ratio: 1.0
        }
    }, {
        id: 'category_parcela',
        type: 'ImageWMS',
        source: {
            url: '/mapserver?map=/data/default.map&project_id=%PROJECT_ID%',
            params: {
                'LAYERS': 'category_parcela',
                'list_name': '',
                'category_name': ''
            },
            ratio: 1.0
        }
    }, {
        id: 'category_cluster',
        type: 'ImageWMS',
        source: {
            url: '/mapserver?map=/data/default.map&project_id=%PROJECT_ID%',
            params: {
                'LAYERS': 'category_cluster',
                'list_name': '',
                'category_name': ''
            },
            ratio: 1.0
        }
    }, {
        id: 'selection_parcela',
        type: 'ImageWMS',
        source: {
            url: '/mapserver?map=/data/default.map&project_id=%PROJECT_ID%',
            params: {'LAYERS': 'selection_parcela'},
            ratio: 1.0
        }
    }, {
        id: 'cuzk_km_i',
        type: 'ImageWMS',
        maxResolution: 2.00025,
        source: {
            url: 'https://services.cuzk.cz/wms/local-KM-wms.asp',
            params: {'LAYERS': 'KN_I'}
        }
    }, {
        id: 'ruian_parcely_hranice',
        type: 'ImageWMS',
        maxResolution: 2.00025,
        source: {
            url: '/mapserver?map=/data/default.map&project_id=%PROJECT_ID%',
            params: {'LAYERS': 'ruian_parcely_hranice'},
            ratio: 1.0
        }
    }, {
        id: 'ruian_katastr_uzemi_hranice',
        type: 'ImageWMS',
        source: {
            url: '/mapserver?map=/data/default.map&project_id=%PROJECT_ID%',
            params: {'LAYERS': 'ruian_katastr_uzemi_hranice'},
            ratio: 1.0
        }
    }, {
        id: 'honitba_hranice',
        type: 'ImageWMS',
        source: {
            url: '/mapserver?map=/data/default.map&project_id=%PROJECT_ID%',
            params: {'LAYERS': 'honitba_hranice'},
            ratio: 1.0
        }
    }],

    virtualLayers: [{
        id: 'base_zm',
        base: true,
        layers: ['zm'],
        title: 'Základní mapa'
    }, {
        id: 'base_orto',
        base: true,
        layers: ['orto'],
        title: 'Letecká mapa'
    }, {
        id: 'base_cuzk_km',
        base: true,
        layers: ['cuzk_km'],
        title: 'Katastrální mapa'
    }, {
        id: 'over_category_parcela',
        layers: ['category_parcela'],
        title: 'Parcely dle kategorie'
    }, {
        id: 'over_selection_parcela',
        layers: ['selection_parcela'],
        title: 'Vybrané parcely'
    }, {
        id: 'over_category_cluster',
        layers: ['category_cluster'],
        title: 'Souvislost dle kategorie'
    }, {
        id: 'over_cuzk_km_i',
        layers: ['cuzk_km_i'],
        title: 'Katastrální mapa inverzní',
        maxResolution: 2.00025
    }, {
        id: 'over_project_hranice',
        layers: ['ruian_parcely_hranice', 'ruian_katastr_uzemi_hranice'],
        title: 'Projekt - hranice parcel a katastrů'
    }, {
        id: 'over_honitba_hranice',
        layers: ['honitba_hranice'],
        title: 'Pomocná liniová vrstva'
    }],

    virtualLayerGroups: [{
        id: 'base',
        base: true,
        title: 'Podkladové vrstvy',
        layers: [
            'base_zm',
            'base_orto',
            'base_cuzk_km'
        ]
    }, {
        id: 'over',
        title: 'Volitelné vrstvy',
        layers: [
            'over_cuzk_km_i',
            'over_project_hranice',
            'over_selection_parcela',
            'over_category_parcela',
            'over_category_cluster',
            'over_honitba_hranice'
        ]
    }],

    defaultVisibleLayers: ['base_zm', 'over_selection_parcela', 'over_category_parcela']

};

export default MAP_PROJECT;
